<script>
export default {
    name: "MorgueDocumentUpload",

    data() {

        return {
            file: {
                name: ``,
            },
        };
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        patient: {
            type: Object,
            required: true,
        },
    },

    methods: {

        saveDocument() {

            const formData = new FormData();
            formData.append(`file`, this.$refs.file.files[0]);

            this.$root.loading = true;
            let url = `Files/PostMorgueDocument`;
                url += `?ID=0`;
                url += `&PatientID=${this.patient.patienT_ID}`;
                url += `&VisitNo=${this.patient.visitNo}`;
                url += `&DocName=${this.file.name}`;
                url += `&contentType=${this.$refs.file.files[0].type}`;
                url += `&UserName=${this.$root.username}`;

            this.$http.post(url, formData).then(({ data }) => {
                this.$refs.file.value = '';
                this.file.name = ``;
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: data, })
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/4 w-1/2">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Morgue: Upload Document</h5>
  </template>
  <template v-slot:modal-body>
    <form id="file-form" 
        @submit.prevent="saveDocument" 
        class="w-full flex flex-wrap items-center">
        <div class="md:w-1/2 w-full p-1">
            <label for="grid-name" class="label-control">Name</label>
            <input type="text"
                id="grid-name"
                v-model.trim="file.name"
                required 
                class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/2 w-full p-1">
            <label for="grid-file" class="label-control">File</label>
            <input type="file" ref="file" 
                id="grid-file"
                required 
                class="input-control input-sm text-xs">
        </div>
    </form>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button
        form="file-form" 
        type="submit"
        class="btn-primary btn-sm text-xs rounded">
            <i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>
